import { render, staticRenderFns } from "./custom-plan-item.vue?vue&type=template&id=0b6365a1&scoped=true&"
import script from "./custom-plan-item.vue?vue&type=script&lang=js&"
export * from "./custom-plan-item.vue?vue&type=script&lang=js&"
import style0 from "./custom-plan-item.vue?vue&type=style&index=0&id=0b6365a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6365a1",
  null
  
)

export default component.exports